{{#custom_css}}
  <style>
    {{custom_css}}
  </style>
{{/custom_css}}
<form class="inline-signup base-email-signup">
  <div class="inline-signup-form-container">
    <h2 class="subscribe-subhead">{{tagline}}{{^tagline}}Sign up for the latest news and analysis.{{/tagline}}</h2>
    <div class="newsletter-options-list">
      {{#newsletters}}
      <label class="newsletter-option-item" tabindex="0">
        <input style="display: none;" type="checkbox" name="{{slug}}" value="{{slug}}" class="newsletter-option-input" {{#default_subscribe}}checked{{/default_subscribe}}>
        <div class="newsletter-option-checkbox">
          <?xml version="1.0" encoding="utf-8"?>
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.36 55.36" style="enable-background:new 0 0 55.36 55.36;" xml:space="preserve" aria-label="checkmark">
            <polyline class="subscribe-checkmark" points="6.29,27.21 23.16,45.21 51.29,9.21 "/>
          </svg>
        </div>
        <div class="newsletter-option-text-container">
          <span class="newsletter-option-description">
            {{short_description}}
          </span>
        </div>
      </label>
      {{/newsletters}}
    </div>
    <div class="subscribe-email-container clearfix">
      <div class="subscribe-column">
        {{! This is a honey-pot field for spambots. A real user should never fill it out. }}
        <input type="text" name="comment" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px">
        <input type="email" {{#display_options}}style="pointer-events: none;"{{/display_options}} name="email" class="subscribe-email-input" placeholder="Enter your email address" value="{{email}}">
      </div>
      <div class="subscribe-column">
        <div class="subscribe-button-js subscribe-button" aria-role="button" tabindex="0">{{ button_text }}</div>
      </div>
    </div>
    <div class="subscribe-managed-label">
      Email list managed by <a class="subscribe-mailchimp-name"  target="_blank" rel="noreferrer" href="https://mailchimp.com/legal/privacy/">Mailchimp</a>
    </div>
    <div class="subscribe-error-container"></div>
  </div>

  <div class="inline-signup-success-container">
    <h2 class="subscribe-subhead">Welcome to our community!</h2>
    <p class="subscribe-next-steps">
      Thanks for trusting us to be your source for urgent investigations and compelling narratives about criminal justice. Readers like you help to make our work possible. Please consider taking the next step and become a member today.
    </p>
    <div class="signup-donate-button-container"><a href="https://donate.themarshallproject.org/?campaign={{ donateCampaign }}" class="donate-button inline-block">Donate</a></div>
  </div>
</form>
